const IS_GAME_ROUTE_FALLBACK = '/'
const FALLBACK_TARGET = '/account'

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) return // fallback if route is not ssr: false in nuxt.config routeRules
  const { isLoggedIn } = useAuth()
  const { navigateToLocalized } = useRouterUtils()

  if (isLoggedIn.value) {
    const query = {
      ...from.query,
      ...to.query,
    }
    const redirect = query.redirect
    const decodedRedirect = redirect ? decodeRedirectQuery(query) : null
    const target = from.meta.isGameRoute ? IS_GAME_ROUTE_FALLBACK : FALLBACK_TARGET

    return navigateToLocalized(
      decodedRedirect === from.fullPath ? target : (decodedRedirect ?? target),
    )
  }
})
